import { NodeViewContent, NodeViewWrapper } from '@tiptap/react';

export const SectionNodeView = () => {
  return (
    <NodeViewWrapper className="react-component bg-blue-500">
      <label contentEditable={false}>React Component</label>

      <NodeViewContent className="content is-editable bg-red-500" />
    </NodeViewWrapper>
  );
};
